export default {
  companionBroker: {
    confetti: {
      heading: 'We can also offer your client a line of credit!',
      subheadings: () => [
        "Your client's business is eligible for FlexiPay, a line of credit they can use to spread business costs.",
        'They can repay over 1, 3, 6, 9 or 12 monthly instalments.',
        'We regularly review credit limits and can give increases to businesses with a good repayment history.'
      ]
    },
    amountApprovedCard: {
      amountApprovedTitle: "Your client's pre-approved credit limit",
      details: () => [
        ['Set up and annual fee', '£0'],
        ['Interest', 'Always 0%'],
        ['Fees', 'from 5.49% (based on a 3 month repayment term)']
      ]
    },
    featuresList: {
      featuresListHeading: 'Thousands of businesses are using FlexiPay to',
      featuresListLabels: () => [
        'Use for any business purpose',
        'Cover everyday expenses on the go',
        'Bulk buy to negotiate a better deal',
        'Pay suppliers, payroll or unexpected invoices',
        'Purchase stock or equipment',
        'Pay VAT, energy or other business bills'
      ]
    },
    disclaimer:
      'If your client decides to set up FlexiPay, we will send all legal documents including FlexiPay in one single email (Docusign) to your client.',
    setupFlexipayRadioGroupHeading:
      'Set up FlexiPay alongside your client’s loan for free?',
    acceptOfferButton: 'Review their loan contract'
  }
};
